export const THEME_DEFAULT = "light";
